import { Form, Modal } from "antd";
import { useSelector } from "react-redux";
import { ModalXIcon } from "../../../../assets/icons";
import InfoText from "../../../commonComponents/InfoText/InfoText";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { fieldsJSON, getWarningObj } from "./utils";
import { useEffect, useMemo, useState } from "react";
import RenderDynamicComponents from "../../../RenderDynamicComponents/RenderDynamicComponents";
import { getObjectChanges } from "../../../../utils";
import { RedWarningModal } from "../../../commonComponents";
import { useDispatch } from "react-redux";
import { showErrorMsg } from "../../../Documentation/utils/Messages";
import { API } from "../../../../helpers/API/amplifyApi";
import { programFields as programFieldsReducer } from "../../../../store/actions";
import Swal from "sweetalert2";

const EMPLOYEE_TEAM_FIELD_ID = "2e9f7112-1775-4b69-b55e-3134333bfdf4";
const COMPANY_CONTACTS_FIELD_ID = "054ebd11-9128-4c78-be38-a0cfabcd3c61";

const NewContactModal = ({ open, setOpen, editingItem }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [
    { isDarkMode },
    { departments },
    { programFields },
    { activeEmployees },
  ] = useSelector((state) => [
    state.usersList,
    state.departments,
    state.programFields,
    state.employeesList,
  ]);

  const [warningModal, setWarningModal] = useState(false);

  const selectedEmployee = Form.useWatch("fullName", form);

  const handleCancel = () => {
    if (!!editingItem) {
      const changes = getObjectChanges(editingItem, form.getFieldsValue());
      if (Object.keys(changes).length) {
        Modal.confirm(
          getWarningObj({
            isDarkMode,
            onConfirm: () => setOpen(false),
            title: "Jeni i sigurt që doni të anuloni?",
            content: "Të gjitha ndryshimet do të humbasin.",
          })
        );
      } else {
        setOpen(false);
      }
    } else {
      const values = form.getFieldsValue();
      if (Object.values(values).some(Boolean)) {
        Modal.confirm(
          getWarningObj({
            isDarkMode,
            onConfirm: () => setOpen(false),
            title: "Jeni i sigurt që doni të anuloni?",
            content: "Të gjitha të dhënat e papërfunduara do të humbasin.",
          })
        );
      } else {
        setOpen(false);
      }
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        const pfIdx = programFields.findIndex(
          (f) => f.fieldId === COMPANY_CONTACTS_FIELD_ID
        );
        if (pfIdx === -1) {
          return showErrorMsg({
            content: "Kontakti nuk u ruajt! Ju lutem provoni përsëri.",
          });
        }

        let newProgramFields = structuredClone(programFields);

        const fieldOptions = newProgramFields[pfIdx].fieldOptions || [];

        if (!!editingItem) {
          const idx = fieldOptions.findIndex(
            (opt) => opt.contactId === editingItem.contactId
          );
          if (idx !== -1) {
            fieldOptions[idx] = { ...fieldOptions[idx], ...values };
          }
        } else {
          fieldOptions.push(values);
        }

        await API.put(
          "programFields",
          `/programFields/${COMPANY_CONTACTS_FIELD_ID}`,
          {
            body: { fieldOptions },
          }
        )
          .then(() => {
            newProgramFields[pfIdx] = {
              ...newProgramFields[pfIdx],
              fieldOptions,
            };
            dispatch(programFieldsReducer(newProgramFields));
            setOpen(false);
            Swal.fire({
              title: `Kontakti u ${!!editingItem ? "modifikua" : "shtua"}!`,
              text: `Ju ${
                !!editingItem ? "modifikuat" : "shtuat"
              } me sukses kontaktin ${values.fullName}`,
              icon: "success",
              customClass: {
                popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
              },
            });
          })
          .catch((err) => {
            Swal.fire({
              title: `Diçka shkoi gabim!`,
              text: `${values.fullName} nuk u shtua dot. Ju lutem provoni përsëri.`,
              icon: "error",
              customClass: {
                popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
              },
            });
            console.log("err: ", err);
          });
      })
      .catch((err) => console.log("err: ", err));
  };

  const fields = useMemo(() => {
    let employeeOptions = [];
    let departmentOptions = [];
    let employeeRoleOptions = [];
    let employeeTeamOptions = [];
    let teamsIdx, contactsIdx;

    const tmpPF = structuredClone(programFields);

    for (const field of tmpPF) {
      if (field.fieldId === COMPANY_CONTACTS_FIELD_ID) {
        contactsIdx = tmpPF.indexOf(field);
      }
      if (field.fieldId === EMPLOYEE_TEAM_FIELD_ID) {
        teamsIdx = tmpPF.indexOf(field);
      }
      if (teamsIdx && contactsIdx) break;
    }
    if (teamsIdx !== -1) {
      const { fieldOptions = [] } = tmpPF[teamsIdx];
      employeeTeamOptions = [...fieldOptions];
    }

    if (activeEmployees?.length) {
      const ids = (tmpPF[contactsIdx].fieldOptions || []).map(
        (opt) => opt.contactId
      );
      employeeOptions = activeEmployees
        .filter((el) => !ids.includes(el.employeeId))
        .map((emp) => ({
          label: emp.employeeFirstName + " " + emp.employeeLastName,
          value: emp.employeeId,
        }));
    }
    if (departments?.length) {
      departmentOptions = departments.map((dep) => dep.departmentName);
      employeeRoleOptions = departments.flatMap((dep) =>
        dep.departmentRoles.map((role) => role.name)
      );
    }

    const fields = fieldsJSON({
      editingItem,
      employeeOptions,
      departmentOptions,
      employeeRoleOptions,
      employeeTeamOptions,
    });

    return fields;
  }, [departments, programFields, activeEmployees]);

  useEffect(() => {
    if (!!selectedEmployee) {
      const employee = activeEmployees.find(
        (emp) => emp.employeeId === selectedEmployee
      );
      if (employee) {
        form.setFieldsValue({
          contactId: selectedEmployee,
          employeeEmail: employee.employeeEmailWork,
          employeeTeam: employee.employeeTeam,
          employeePhoneNumber: employee.employeePhoneNumber,
          department: employee.employeeDepartmentName,
          employeeRoleName: employee.employeeRoleName,
          googleDriveFileId: employee.googleDriveFileId,
          fullName:
            employee.employeeFirstName + " " + employee.employeeLastName,
        });
      }
    }
  }, [selectedEmployee]);

  useEffect(() => {
    if (!editingItem) return;

    form.setFieldsValue(editingItem);
  }, [editingItem]);

  //region RETURN
  return (
    <Modal
      centered
      open={open}
      closeIcon={<ModalXIcon />}
      onCancel={handleCancel}
      destroyOnHidden
      title={
        editingItem
          ? `Modifiko ${editingItem.fullName}`
          : "Krijo një kontakt të ri"
      }
      className={`newContactModal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
      footer={[
        <MondayButton className="mondayButtonGrey" onClick={handleCancel}>
          Anuloni {editingItem ? "ndryshmet" : "krijimin"}
        </MondayButton>,
        <MondayButton className="mondayButtonGreen" onClick={handleSubmit}>
          Konfirmoni {editingItem ? "ndryshmet" : "krijimin"}
        </MondayButton>,
      ]}
    >
      <div className="newContactModalContent">
        <InfoText text="Plotësoni formularin më poshtë për të shtuar një kontakt të ri." />
        <Form form={form}>{RenderDynamicComponents(fields, { form })}</Form>
      </div>
      {!!warningModal ? (
        <RedWarningModal
          onCancel={setWarningModal}
          visible={warningModal.open}
          setVisible={setWarningModal}
          confirmModal={warningModal.confirmModal}
          footerProps={{ onConfirm: warningModal.onConfirm }}
        >
          <h3>{warningModal.title}</h3>
          <p>{warningModal.content}</p>
        </RedWarningModal>
      ) : null}
    </Modal>
  );
};

export default NewContactModal;
